import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import PageNotFound from '@/views/PageNotFound.vue'
//-----------About us Menu components-----------------------------
import AboutView from '@/views/AboutView.vue'
import OurPurpose from '@/views/OurPurpose.vue'
import CorporateGovernance from '@/views/CorporateGovernance.vue'
import OurLeadership from '@/views/OurLeadership.vue'
import OurContact from '@/views/OurContact.vue'

//-----------Operations components----------------------------------
import OperationsOverview from '@/views/OperationsOverview.vue'
import OurProducts from '@/views/OurProducts.vue'
import OurReservesnResources from '@/views/OurReservesnResources.vue'
import OurExploration from '@/views/OurExploration.vue'
import OurportfolioAssets from '@/views/OurportfolioAssets.vue'

//-----------Sustainability Menu components-------------------------
import SustainabilityOVerview from '@/views/SustainabilityOverview.vue'
import ManagementApproach from '@/views/ManagementApproach.vue'
import ManagementApproachmanagement from '@/views/ManagementApproachmanagement.vue'
import HumanRights from '@/views/HumanRights.vue'
import PoliciesandCommitment from '@/views/PoliciesandCommitment.vue'
import GoalsnPerformance from '@/views/GoalsnPerformance.vue'
import SustainabilityReporting from '@/views/SustainabilityReporting.vue'
import OurEnvironment from '@/views/OurEnvironment.vue'
import WaterStewardship from '@/views/WaterStewardship.vue'
import BioDiversity from '@/views/BioDiversity.vue'
import ClimateChange from '@/views/ClimateChange.vue'
import TailingwasteManagement from '@/views/TailingwasteManagement.vue'
import MineClosure from '@/views/MineClosure.vue'
import EconomicImpact from '@/views/EconomicImpact.vue'
import CommunitiesnIndigenous from '@/views/CommunitiesnIndigenous.vue'
import HealthnSafety from '@/views/HealthnSafety.vue'
import InclusionnDiversity from '@/views/InclusionnDiversity.vue'
import HumanCapital from '@/views/HumanCapital.vue'
import SecurityManagement from '@/views/SecurityManagement.vue'
import OurGovernance from '@/views/OurGovernance.vue'
import BusinessEthics from '@/views/BusinessEthics.vue'
import ShareholderInformation from '@/views/ShareholderInformation.vue'

//-----------Invest Menu components-------------------------
import InvestOverview from '@/views/InvestOverview.vue'
import OurTransaction from '@/views/OurTransaction.vue'
import FinancialreportFiling from '@/views/FinancialreportFiling.vue'
import EventsnPresentation from '@/views/EventsnPresentation.vue'
import OurDividends from '@/views/OurDividends.vue'
import OurAudits from '@/views/OurAudits.vue'
import OurPasperf from '@/views/OurPasperf.vue'
import OurNews from '@/views/OurNews.vue'
import CareersOverview from '@/views/CareersOverview.vue'
import OurSocial from '@/views/OurSocial.vue'
import NewsReading from '@/views/NewsReading.vue'
import JobPosting from '@/views/JobPosting.vue'
import JoinOurteam from '@/views/JoinOurteam'




//Login and Register Components
import LoginView from '@/views/LoginView.vue'
import RegisterView from '@/views/RegisterView.vue'
import OtpVerify from '@/views/OtpVerify.vue'
import ForgotPassword from '@/components/ForgotPassword.vue'
import ResetPassword from '@/components/ResetPassword.vue'

// const locale = localStorage.getItem('lang');


//English Language Routes

const routes = [
  { path: '/', name: 'Home', component: HomeView,},
  { path: '/', name: 'Accueil', component: HomeView,},
  { path: '/pagenotfound', name: 'Page-Not-Found', component: PageNotFound,},
 //------------------About Menu Routes------------------------
  { path: '/about', name: 'About', component: AboutView,},
  { path: '/a-propos', name: 'A-propos', component: AboutView,},


  { path: '/about/Our-purpose', name: 'Our-purpose', component: OurPurpose,},
  { path: '/a-propos/Notre-objectif', name: 'Notre-objectif', component: OurPurpose,},


  { path: '/about/Corporate-governance', name: 'Corporate-governance', component: CorporateGovernance,},
  { path: '/a-propos/Gouvernance-entreprise', name: 'Gouvernance-entreprise', component: CorporateGovernance,},


  { path: '/about/leadership', name: 'Leadership', component: OurLeadership,},
  { path: '/a-propos/direction', name: 'Direction', component: OurLeadership,},

  { path: '/about/contact-us', name: 'OurContact', component: OurContact,},
  { path: '/a-propos/contact', name: 'Contact', component: OurContact,},

  //------------------Operations Menu Routes------------------------
  { path: '/operations/overview', name: 'OperationsOverview', component: OperationsOverview,},
  { path: '/operations/apercu', name: 'apercuoperations', component: OperationsOverview,},

  { path: '/operations/our-products', name: 'OurProducts', component: OurProducts,},
  { path: '/operations/nos-produits', name: 'Nosproduits', component: OurProducts,},

  { path: '/operations/our-reserves-and-resources', name: 'OurReservesnResources', component: OurReservesnResources,},
  { path: '/operations/nos-reserves-et-ressources', name: 'Nosreservesetressources', component: OurReservesnResources,},

  { path: '/operations/our-exploration', name: 'OurExploration', component: OurExploration,},
  { path: '/operations/notre-exploration', name: 'Notreexploration', component: OurExploration,},

  { path: '/operations/other-portfolio-assets', name: 'OurportfolioAssets', component: OurportfolioAssets,},
  { path: '/operations/autres-actifs-du-portefeuille', name: 'autresactifsduportefeuille', component: OurportfolioAssets,},


  //------------------SUSTAINABILITY MENU ROUTES------------------------
  { path: '/sustainability/overview', name: 'SustainabilityOVerview', component: SustainabilityOVerview,},
  { path: '/durabilite/apercu', name: 'durabiliteapercu', component: SustainabilityOVerview,},


  { path: '/sustainability/approach-performance', name: 'ManagementApproach', component: ManagementApproach,},
  { path: '/durabilite/demarche-performance', name: 'Demarcheperformance', component: ManagementApproach,},


  { path: '/sustainability/our-approach-and-performance/management-approach', name: 'ManagementApproachmanagement', component: ManagementApproachmanagement,},
  { path: '/durabilite/notre-approche-et-performance/approche-manageriale', name: 'Demarcheperformancemanageriale', component: ManagementApproachmanagement,},

  { path: '/sustainability/our-approach-and-performance/human_rights', name: 'HumanRights', component: HumanRights,},
  { path: '/durabilite/notre-approche-et-performance/droits_humains', name: 'DroitsHumains', component: HumanRights,},

  { path: '/sustainability/our-approach-and-performance/policies-and-commitments', name: 'PoliciesandCommitment', component: PoliciesandCommitment,},
  { path: '/durabilite/notre-approche-et-performance/politiques-et-engagements', name: 'politiquesengagements', component: PoliciesandCommitment,},
  //------------------------------------------
  { path: '/sustainability/our-approach-and-performance/goals_and_performance', name: 'GoalsnPerformance', component: GoalsnPerformance,},
  { path: '/durabilite/notre-approche-et-performance/objectifs-et-performance', name: 'objectifsperformance', component: GoalsnPerformance,},
  //------------------------------------------
  { path: '/sustainability/sustainability_Reporting', name: 'SustainabilityReporting', component: SustainabilityReporting,},
  { path: '/durabilite/durabilite_Rapports', name: 'DurabiliteRapports', component: SustainabilityReporting,},
  //------------------------------------------
  { path: '/sustainability/environment', name: 'OurEnvironment', component: OurEnvironment,},
  { path: '/durabilite/environnement', name: 'Environnement', component: OurEnvironment,},
  //------------------------------------------

  { path: '/sustainability/environment/water_stewardship', name: 'WaterStewardship', component: WaterStewardship,},
  { path: '/durabilite/environnement/gestion-de-l eau', name: 'Gestiondeleau', component: WaterStewardship,},

  //------------------------------------------
  { path: '/sustainability/environment/biodiversity', name: 'BioDiversity', component: BioDiversity,},
  { path: '/durabilite/environnement/biodiversite', name: 'Biodiversite', component: BioDiversity,},
  //------------------------------------------
  { path: '/sustainability/environment/climate-change-&-energy', name: 'ClimateChange', component: ClimateChange,},
  { path: '/durabilite/environnement/changement-climatique-et-energie', name: 'climatiqueetenergie', component: ClimateChange,},
  //------------------------------------------
  { path: '/sustainability/environment/waste_management', name: 'TailingwasteManagement', component: TailingwasteManagement,},
  { path: '/durabilite/environnement/gestion-des-dechets', name: 'gestiondesdechets', component: TailingwasteManagement,},
  //------------------------------------------
  { path: '/sustainability/environment/mine_closure', name: 'MineClosure', component: MineClosure,},
  { path: '/durabilite/environnement/fermeture-de-la-mine', name: 'fermeturedelamine', component: MineClosure,},

  //------------------------------------------
  { path: '/sustainability/social/', name: 'OurSocial', component: OurSocial,},
  { path: '/durabilite/sociale/Notre-reseau-social', name: 'NotreReseauSocial', component: OurSocial,},


  //------------------------------------------
  { path: '/sustainability/social/economic-impact', name: 'EconomicImpact', component: EconomicImpact,},
  { path: '/durabilite/sociale/impact-economique', name: 'Impacteconomique', component: EconomicImpact,},

  //------------------------------------------
  { path: '/sustainability/social/indigenous-communities', name: 'CommunitiesnIndigenous', component: CommunitiesnIndigenous,},
  { path: '/durabilite/sociale/communautes-autochtones', name: 'Communitiesautochtones', component: CommunitiesnIndigenous,},
  //------------------------------------------
  { path: '/sustainability/social/health-and-safety', name: 'HealthnSafety', component: HealthnSafety,},
  { path: '/durabilite/sociale/sante-et-securite', name: 'Santeetsecurite', component: HealthnSafety,},

  //------------------------------------------
  { path: '/sustainability/social/inclusion-and-diversity', name: 'InclusionnDiversity', component: InclusionnDiversity,},
  { path: '/durabilite/sociale/inclusion-et-diversite', name: 'InclusionetDiversite', component: InclusionnDiversity,},

  //------------------------------------------
  { path: '/sustainability/social/human-capital-development', name: 'HumanCapital', component: HumanCapital,},
  { path: '/durabilite/sociale/developpement-du-capital-humain', name: 'humainCapital', component: HumanCapital,},
  //------------------------------------------
  { path: '/sustainability/social/security-management', name: 'SecurityManagement', component: SecurityManagement,},
  { path: '/durabilite/sociale/gestion-de-la-securite', name: 'SecuriteManagement', component: SecurityManagement,},

  //------------------------------------------
  { path: '/sustainability/social/governance', name: 'OurGovernance', component: OurGovernance,},
  { path: '/durabilite/sociale/notre-gouvernance', name: 'NotreGouvernance', component: OurGovernance,},

  //------------------------------------------
  { path: '/sustainability/governance/business-ethics', name: 'BusinessEthics', component: BusinessEthics,},
  { path: '/durabilite/governance/ethique-des-affaires', name: 'affairesEthics', component: BusinessEthics,},

    //------------------------------------------
  

  //------------------INVEST MENU ROUTES------------------------
  { path: '/invest/overview', name: 'InvestOverview', component: InvestOverview,},
    { path: '/investir/apercu', name: 'InvestirApercu', component: InvestOverview,},
  //------------------------------------------
  { path: '/invest/our-transactions', name: 'OurTransaction', component: OurTransaction,},
  { path: '/investir/nos-transactions', name: 'Nostransactions', component: OurTransaction,},
  //------------------------------------------
  { path: '/invest/financial-report-filing', name: 'FinancialreportFiling', component: FinancialreportFiling,},
  { path: '/investir/depot-de-rapports-financiers', name: 'FinanciersreportFiling', component: FinancialreportFiling,},
  //------------------------------------------
  { path: '/invest/events-and-presentation', name: 'EventsnPresentation', component: EventsnPresentation,},
  { path: '/investir/evenements-et-presentation', name: 'Evenementsetpresentation', component: EventsnPresentation,},
  //------------------------------------------
  { path: '/invest/shareholder-information', name: 'ShareholderInformation', component: ShareholderInformation,},
  { path: '/investir/informations-actionnaires', name: 'ActionnairesInformation', component: ShareholderInformation,},
  //------------------------------------------
  { path: '/invest/shareholder-information/our-dividends', name: 'OurDividends', component: OurDividends,},
  { path: '/investir/informations-actionnaires/nos-dividendes', name: 'OurDividendes', component: OurDividends,},
  //------------------------------------------
  { path: '/invest/shareholder-information/audits', name: 'OurAudits', component: OurAudits,},
  { path: '/investir/informations-actionnaires/verifications', name: 'verifications', component: OurAudits,},
  //------------------------------------------
  { path: '/invest/shareholder-information/paasf', name: 'OurPasperf', component: OurPasperf,},
  { path: '/investir/informations-actionnaires/paasfs', name: 'OurPasperfs', component: OurPasperf,},

  //------------------------------------------
  { path: '/news/news-releases', name: 'OurNews', component: OurNews,},
  { path: '/nouvelles/communiques-de-presse', name: 'communiquesdepresse', component: OurNews,},

  { path: '/news/read-news/:hpnewsid', name: 'newsreading', component: NewsReading,},
  { path: '/nouvelles/lecture-de-nouvelles/:hpnewsid', name: 'lecturedenouvelles', component: NewsReading,},

  { path: '/careers/overview', name: 'careersoverview', component: CareersOverview,},
  { path: '/carrieres/apercu', name: 'careersfroverview', component: CareersOverview,},

  
  { path: '/careers/job-posting/:jobid', name: 'jobposting', component: JobPosting,},
  { path: '/carrieres/offre-d\'emploi/:jobid', name: 'offredeemploi', component: JobPosting,},

  //------------------------------------------
  { path: '/careers/join-our-team', name: 'joinourteam', component: JoinOurteam,},
  { path: '/carrieres/rejoins-notre-equipe', name: 'rejoinsnotreequipe', component: JoinOurteam,},
// { path: '/news/news-releases', name: 'OurNews', component: OurNews,
// meta: {
//   breadCrumb: [
//     {name: 'Home', link: '/' },
//     {name: 'OurNews' }//crumb
//   ]
//  }
// },
// //------------------------------------------
// { path: '/sustainability/social', name: 'OurSocial', component: OurSocial,
// meta: {
//   breadCrumb: [
//     {name: 'Home', link: '/' },
//     {name: 'OurSocial' }//crumb
//   ]
//  }
// },
// { path: 'sustainability/sociale', name: 'Sociale', component: OurSocial,
// meta: {
//   breadCrumb: [
//     {name: 'Home', link: '/' },
//     {name: 'Sociale' }//crumb
//   ]
//  }
// },
// //------------------------------------------
// { path: '/sustainability/governance', name: 'OurGovernance', component: OurGovernance,
// meta: {
//   breadCrumb: [
//     {name: 'Home', link: '/' },
//     {name: 'OurGovernance' }//crumb
//   ]
//  }
// },
// { path: '/sustainability/gouvernance', name: 'OurGovernance', component: OurGovernance,
// meta: {
//   breadCrumb: [
//     {name: 'Home', link: '/' },
//     {name: 'OurGovernance' }//crumb
//   ]
//  }
// },





//------------------Login Routes----------------------------------
  { path: '/login', name: 'login', component: LoginView,
  meta: {
    breadCrumb: [
      {name: 'Home', link: '/' },
      {name: 'Login' }//crumb
    ]
  }
  },
  { path: '/register', name: 'register', component: RegisterView,
  meta: {
    breadcrumb: [
      {name: 'Home', link: '/' },
      {name: 'Register' }//crumb
    ]
  }
  },
  { path: '/otpverify', name: 'optverify', component: OtpVerify,
  meta: {
    breadcrumb: [
      {name: 'Home', link: '/' },
      {name: 'Otpverify'},
    ]
  }
  },
  { path: '/forgotpassword', name: 'forgotpassword', component: ForgotPassword,
    meta: {
      breadcrumb: [
        {name: 'Home', link: '/' },
        {name: 'Forgot Password' }//crumb
      ]
    }
  },
  { path: '/password-reset-confirm/:uidb64/:token', name: 'password-reset-confirm', component: ResetPassword,
    meta: {
      breadcrumb: [
        {name: 'Home', link: '/' },
        {name: 'Password Reset' }//crumb
      ]
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

